import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import GraphReport from "./GraphReport";
import ServicesEnabled from "./ServicesEnabled";
import NewUpdates from "./NewUpdates";
import { ContentStyle } from "../../Theme";

export default function Dashboard() {
  return (
    <>
      <ContentStyle>
        <Typography component="h6" color="primary" variant="h6">
          Dashboard
        </Typography>
        <Grid
          container
          item
          xs={12}
          spacing={2}
          alignItems="top"
          justifyContent="center"
        >
          <Grid item xs={12} md={8} lg={8}>
            <ServicesEnabled />
            <GraphReport />
          </Grid>
          <Grid item xs={12} md={4} lg={4}>
            <NewUpdates />{" "}
          </Grid>
        </Grid>
      </ContentStyle>
    </>
  );
}
